
import React from 'react';

const PlanHtmlBuilder =({PlanData})=>{
   const PlanHtmlArray = [];
      PlanData.map(item => {
        item && ((item.isTheFreeTrial && item.isFreeTrialEnabled) || !(item.isTheFreeTrial)) &&
        PlanHtmlArray.push(
          <div id={item.id} >
            <div className='plan-info'>
              <div className='plan-name'>
              {item.planName}
              </div>
              {!item.isFreeTrialEnabled && !item.isTheFreeTrial
                ?<div className='plan-details'>
                  {
                    item.billingType === 'TRANSACTIONAL'
                    ? item.transactionalTypeOptions === '$'
                      ? <div className='billing-cost'>
                          {`${item.transactionalTypeOptions} ${item.includedTransactionalFee || '0'} / ${item.includedTransactionalType}`}
                        </div>
                      : <div className='billing-cost'>
                          {`${item.includedTransactionalFee || '0'}${item.transactionalTypeOptions} / ${item.includedTransactionalType}`}
                        </div>
                    : null
                  }
                  {
                    item.billingType === 'ONE TIME'
                    ? <div className='billing-cost'>
                        {`$ ${item.basePrice || '0'}`}
                      </div>
                    : null
                  }
                  {
                    item.billingType === 'RECURRING'
                    ? <div className='billing-cost'>
                        {`$ ${item.basePrice || '0'} / ${item.billingFrequency}`}
                      </div>
                    : null
                  }
                  {
                    item.billingType === 'FREE'
                    ? <div className='billing-cost'>
                        {`$ ${item.basePrice || '0'}`}
                      </div>
                    : null
                  }
                </div>
                :<div className='free-trial-cost'>{'$ 0'}</div>
              }
            </div>
            <div className='plan-details'>
            <div className='billing-type'>
              {!item.isFreeTrialEnabled && !item.isTheFreeTrial
                ? <div>
                    BillingType: {`${item.billingType} `}
                  </div>
                :null
              }
              </div>
              {
                item.includedUnitQuantity && item.includedUnitOfMeasure 
                ? 
                  <div className='billing-cost'>
                    {`Up to ${item.includedUnitQuantity} ${item.includedUnitOfMeasure}`}
                  </div>
                  :null
              }
            </div>
            
          </div>
        );
      });
      return PlanHtmlArray;
}

export default PlanHtmlBuilder;